import { useQuery } from "@tanstack/react-query";
import { GetCurrency } from "../Services/common";

export const useCurrency = () => {
    return useQuery({
        queryKey: ["currency"],
        queryFn: GetCurrency,
        staleTime: 10 * 60 * 1000, // cache for 10 minutes
    });
};